import React from 'react';
import { Navigate, createBrowserRouter } from 'react-router-dom';
import AuthLayout from '../components/AuthLayout';
import Login from '../pages/Auth/Login';
import Forget from '../pages/Auth/Forget';
import Signup from '../pages/Auth/Signup';
import Password from '../pages/Auth/Signup/Password';
import NewPassword from '../pages/Auth/Signup/NewPassword';
import AvatarUpload from '../pages/Auth/Avatar';

export const routes = createBrowserRouter([
  // {
  //   path: '/',
  //   // element: <AuthLayout />,
  //   children: [
  //     {
  //       path: '',
  //       element: <CreateProject />
  //     }
  //   ]
  // },
  // {
  //   path: '/',
  //   // element: <Layout />,
  //   children: [
  //     {
  //       path: 'data-extraction/:id/:quarter/:year',
  //       children: [
  //         {
  //           index: true,
  //           element: <DataExtraction />
  //         }
  //       ]
  //     }
  //   ]
  // },
  {
    path: '/auth',
    element: <AuthLayout />,
    children: [
      {
        path: 'login',
        element: <Login />
      },
      {
        path: 'signup',
        element: <Signup />
      },
      {
        path: 'forget',
        element: <Forget />
      },
      {
        path: 'password',
        element: <Password />
      },
      {
        path: 'new-password',
        element: <NewPassword />
      },
      {
        path: 'avatar',
        element: <AvatarUpload />
      },
      {
        index: true,
        element: <Navigate to="login" />
      }
    ]
  },
  {
    path: '*',
    element: <Navigate to="/auth" />
  }
]);
